<template>
  <b-modal
    size="lg"
    :id="'modal-reference' + roomInfoData.id"
    :title="groupReservationTitle"
    ok-only
    no-close-on-backdrop
    no-close-on-esc
    hide-footer
    class="status"
    :no-enforce-focus='true'
    @show="resetData"
  >
    <b-card-text>
      <h4>Información de la Reservación</h4>

      <b-tabs>
        <b-tab title="General">
          <ValidationObserver ref="ModalEditBookingGroupForm">
            <b-row>
              <b-col md="2">
                <ValidationProvider name="Prefijo" rules="required">
                  <b-form-group label="Prefijo" slot-scope="{ valid, errors }">
                    <b-form-select
                      :state="errors[0] ? false : valid ? true : null"
                      v-model="room.nameprefix"
                      :disabled="invalid"
                    >
                      <option value="0">Seleccione una opción</option>
                      <option
                        v-for="(namesF, index) in namesPrefix"
                        :key="index"
                        :value="namesF.value"
                      >
                        {{ namesF.text }}
                      </option>
                    </b-form-select>
                    <b-form-invalid-feedback>
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <b-col md="4">
                <ValidationProvider rules="required" name="Nombre">
                  <b-form-group slot-scope="{ valid, errors }" label="Nombre">
                    <b-form-input
                      type="text"
                      :disabled="invalid"
                      v-model="room.givenname"
                      :state="errors[0] ? false : valid ? true : null"
                    >
                    </b-form-input>
                  </b-form-group>
                </ValidationProvider>
              </b-col>
              <b-col md="6">
                <ValidationProvider rules="required" name="Apellido">
                  <b-form-group slot-scope="{ valid, errors }" label="Apellido">
                    <b-form-input
                      type="text"
                      :disabled="invalid"
                      v-model="room.surname"
                      :state="errors[0] ? false : valid ? true : null"
                    >
                    </b-form-input>
                  </b-form-group>
                </ValidationProvider>
              </b-col>
              <b-col md="6">
                <ValidationProvider rules="required" name="Correo">
                  <b-form-group slot-scope="{ valid, errors }" label="Correo">
                    <b-form-input
                      type="text"
                      :disabled="invalid"
                      v-model="room.email"
                      :state="errors[0] ? false : valid ? true : null"
                    >
                    </b-form-input>
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <b-col md="6">
                <ValidationProvider rules="required" name="teléfono">
                  <b-form-group slot-scope="{ valid, errors }" label="Teléfono">
                    <b-form-input
                      type="text"
                      :disabled="invalid"
                      @keypress="formatPhoneNumber"
                      v-model="room.phonenumber"
                      :state="errors[0] ? false : valid ? true : null"
                    >
                    </b-form-input>
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <b-col md="3">
                <b-form-group>
                  <label><strong>Check in - Check out*</strong></label>
                  <flat-pickr
                    v-model="rangeDate"
                    class="form-control"
                    :config="configRangeDate"
                    @input="setRangeDaysAndTotalNights(rangeDate)"
                  />
                </b-form-group>
              </b-col>

              <b-col md="3">
                <ValidationProvider name="Noches">
                  <b-form-group slot-scope="{ isValidNights, errors }" label="Noches">
                    <b-form-input
                      type="number"
                      :disabled="true"
                      v-model="room.nights"
                      :state="errors[0] ? false : isValidNights ? true : null"
                    >
                    </b-form-input>
                  </b-form-group>
                </ValidationProvider>
                <label v-if="isValidNights" class="nightsValid">Noches invalidas </label>
              </b-col>

              <b-col md="3">
                <ValidationProvider name="Tarifa">
                  <b-form-group slot-scope="{ isValidNights }" label="Tarifa">
                    <b-form-input
                      type="number"
                      :disabled="true"
                      v-model="room.rateInit"
                      @input="getNights(room)"
                      :state="isValidNights"
                    >
                    </b-form-input>
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <b-col md="3">
                <ValidationProvider name="Total">
                  <b-form-group label="Total">
                    <b-form-input
                      type="number"
                      :disabled="true"
                      v-model="room.total"
                    >
                    </b-form-input>
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <b-col md="12" v-if="availability">
                <b-alert variant="danger" show>
                  <div class="alert-body text-center">
                    <span>
                      <strong>¡Sin Tarifas! </strong>No se encontro
                      disponibilidad.
                    </span>
                  </div>
                </b-alert>
              </b-col>
              <b-col md="6">
                <ValidationProvider rules="required" name="Tipo de Cuarto">
                  <b-form-group
                    :disabled="invalid"
                    slot-scope="{ valid, errors }"
                    label="Tipo de Cuarto"
                  >
                    <b-form-select
                      v-model="room.roomtypecode"
                      :state="errors[0] ? false : valid ? true : null"
                      @change="validMaxPax(room.roomtypecode)"
                    >
                      <option
                        v-for="roomsItems in room.roomslist"
                        :key="roomsItems.room_id"
                        :value="roomsItems.roomtypecode"
                      >
                        {{ roomsItems.roomtypename }} | {{ roomsItems.rooms }}
                      </option>
                    </b-form-select>
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <b-col md="2">
                <b-form-group>
                  <validation-provider name="Adultos">
                    <b-form-group slot-scope="{ errors }" label="Adultos*">
                      <b-form-select
                        :disabled="invalid"
                        v-model="room.adults"
                        @input="setCanEdit()"
                        :state="errors.length > 0 ? false : null"
                      >
                        <!-- @input="setDataForm" -->
                        <option
                          v-for="(adulto, index) in validPax.adults"
                          :key="index"
                          :value="adulto"
                        >
                          {{ adulto }}
                        </option>
                      </b-form-select>
                      <b-form-invalid-feedback>
                        {{ errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col md="2" v-if="validPax.canBookChildren">
                <b-form-group>
                  <validation-provider
                    #default="{ errors }"
                    name="Niños"
                  >
                    <label for="children">Niños*</label>
                    <b-form-select
                      :disabled="invalid"
                      v-model="room.children"
                      :state="errors.length > 0 ? false : null"
                      @input="createArrayNinios(room), setCanEdit()"
                    >
                      <option value="0">0</option>
                      <option
                        v-for="(children, index) in validPax.children"
                        :key="index"
                        :value="children"
                      >
                        {{ children }}
                      </option>
                    </b-form-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="2" class="buttonUpdate">
                <b-button
                  class="mt-2"
                  style="font-size:13px;"
                  :disabled="(isValidNights || ismaxPax) || isRoomFull || isSaving || isUpdating"
                  variant="primary"
                  @click="updateRates(room)"
                >
                  Actualizar <b-spinner small v-if="isUpdating" />
                </b-button>
              </b-col>

              <b-col md="12" v-if="ismaxPax">
                <label class="nightsValid">Numero de pax maximo N° {{ validPax.pax }} </label>
              </b-col>

              <b-col md="4 mb-1" v-for="(child, index) in room.booking.ninios" :key="index">
                <label :for="'AgeChild' + index">Edad niño {{ index + 1 }}*</label>
                <b-input-group>
                  <b-form-select
                    :disabled="invalid"
                    :id="'AgeChild' + index"
                    v-model="room.booking.ninios[index].edad"
                    @change="setAgeNinio(index, room.booking.ninios[index].edad, room), setCanEdit()"
                  >
                    <option
                      v-for="(edad, index) in ageChildrenOptions"
                      :key="index"
                      :value="edad.value"
                    >
                      {{ edad.text }}
                    </option>
                  </b-form-select>
                  <b-input-group-append>
                    <b-button
                      variant="danger"
                      size="sm"
                      @click="deleteAgeChild(index, room)"
                    >
                      <b-icon icon="trash-fill"></b-icon>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-col>

              <b-col md="12">
                <b-form-group label="Referido">
                  <b-form-select :disabled="invalid" v-model="room.reference">
                    <option :value="null">Seleccione Referido</option>
                    <option v-for="(reference, index) in groupData.referenceList" :key="index" :value="reference">
                      {{ reference }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>

              <b-col md="12" class="mt-2">
                <div class="float-right">
                  <b-button :disabled="invalid || isEdit || isValidNights || isSaving" variant="primary"
                    @click="updateRoom(room)">
                    {{ isSaving ? "Guardando" : "Guardar" }} <b-spinner small v-if="isSaving" />
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </ValidationObserver>
        </b-tab>

        <b-tab title="Pagos">
          <ValidationObserver ref="ModalPaymentBookingGroupForm">
            <b-row v-if="applyPayment && can('groups_menu_can_pay_group_bookings')">
              <b-col md="12">
                <h5 class="listPayTitle">Aplicar pago</h5>
              </b-col>
              <b-col md="4">
                <ValidationProvider rules="required" name="Forma de pago">
                  <b-form-group slot-scope="{valid, errors}" label="Forma de pago">
                    <b-form-select
                        :state="errors[0] ? false : (valid ? true : null)"
                        v-model="payment.paymentMethod"
                      >
                        <option :value="null" disabled>Elija método de pago</option>
                        <option v-for="pm in paymentMethodList" :key="pm.id" :value="pm.id">
                          {{ pm.name }}
                        </option>
                      </b-form-select>
                    <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <b-col md="4">
                <ValidationProvider rules="required" name="Fecha de pago">
                  <b-form-group slot-scope="{valid, errors}" label="Fecha de pago">
                    <flat-pickr
                      :config="{maxDate: 'today'}"
                      v-model="payment.paymentDate"
                      :class="`form-control flatpickr-color ${errors.length > 0 ? 'is-invalid' : 'is-valid'}`"
                      :state="errors[0] ? false : valid ? true : null"
                    />
                    <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <b-col md="4">
                <ValidationProvider rules="required" name="Moneda">
                  <b-form-group slot-scope="{valid, errors}" label="Moneda">
                    <b-form-select
                      :state="errors[0] ? false : (valid ? true : null)"
                      v-model="payment.currency"
                    >
                      <option :value="null" disabled>Elija método de pago</option>
                      <option v-for="cur in currencyList" :key="cur.currencyid" :value="cur.currencyid">
                        {{ cur.name }}
                      </option>
                    </b-form-select>
                    <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <b-col md="4">
                <ValidationProvider :rules="{ required: true, min_value: 1 }" name="Importe">
                  <b-form-group slot-scope="{valid, errors}" label="Importe">
                    <b-form-input type="number" :disabled="invalid"
                      v-model="payment.amount"
                      :state="errors[0] ? false : valid ? true : null"
                    ></b-form-input>
                    <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                    <b-badge variant="success" class="mt-1" v-if="selectedCurrency && selectedCurrency.value != 1">USD {{ formatCurrency(currencyAmount) }}</b-badge>
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <b-col md="8">
                <ValidationProvider name="Referencia">
                  <b-form-group slot-scope="{valid, errors}" label="Referencia">
                    <b-form-input
                      type="text"
                      v-model="payment.reference"
                      :state="errors[0] ? false : valid ? true : null"
                    ></b-form-input>
                    <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <b-col md="12">
                <div class="text-right">
                  <b-button
                    :disabled="isProcessingPayment"
                    variant="warning"
                    @click="setPaymentForm"
                    class="mr-1"
                  > Cancelar
                  </b-button>

                  <b-button :disabled="isProcessingPayment" variant="primary"
                    @click="makePayment()">
                    {{ isProcessingPayment ? "Aplicando" : "Aplicar pago" }} <b-spinner small v-if="isProcessingPayment" />
                  </b-button>
                </div>
                <hr>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="12" v-if="room.listPayOrders.length != 0 && show == true">
                <div class="d-flex justify-content-between">
                  <strong class="listPayTitle">Detalle de pagos </strong>
                </div>
                <b-row class="mb-1" align-v="center">
                  <b-col>
                    <strong>Total:</strong> {{ formatCurrency(room.total) }}
                  </b-col>
                  <b-col>
                    <strong>Pagado:</strong> {{ formatCurrency(room.orderdetail.totalpay) }}
                  </b-col>
                  <b-col>
                    <strong>Balance:</strong> {{ formatCurrency(room.orderdetail.balance) }}
                  </b-col>
                  <b-col class="text-right">
                    <b-button v-if="balanceBooking>1 && !applyPayment && can('groups_menu_can_pay_group_bookings')" @click="setPaymentForm" size="sm" variant="primary">Aplicar pago</b-button>
                  </b-col>
                </b-row>
                <b-table
                  :items="room.listPayOrders"
                  :fields="canRefundPayments ? fieldsFull : fields"
                  responsive
                  small
                  :busy.sync="isLoadingTransactions"
                >
                  <template #table-busy>
                    <div class="text-center my-2">
                      <b-spinner class="align-middle"></b-spinner> <br>
                      <strong>Cargando registros de pago</strong>
                    </div>
                  </template>
                  <template #cell()="data">
                    <span class="p-half">
                      {{ data.value}}
                    </span>
                  </template>

                  <template #cell(actions)="row">
                    <div class="text-center" v-if="row.item.trans_status == 'Approved'">
                      <b-button size="sm" variant="danger" @click.prevent="cancelPayment(row.item.ordertrans_id)">
                        <feather-icon icon="DollarSignIcon" size="12" />
                      </b-button>
                    </div>
                  </template>
                </b-table>
              </b-col>
            </b-row>
          </ValidationObserver>
        </b-tab>
      </b-tabs>
    </b-card-text>
  </b-modal>
</template>

<script>
import * as moment from "moment";
import { mapState, mapActions, mapMutations } from "vuex";
import { currentDate, makeTime, showAlertMessage, sweetAlert, toCurrency } from "@/helpers/helpers"
import { adultOptions, childrenOptions, ageChildrenOptions, namesPrefix } from "@/data/data"
import { acl } from "@/modules/auth/mixins/acl"
import flatPickr from 'vue-flatpickr-component'
export default {
  mixins: [acl],
  props: {
    room: {
      type: Object,
      required: true,
    },
    roomCode: {
      type: String,
      required: true,
    },
    roomInfoData: {
      type: Object,
      required: true,
    },
    groupData: {
      type: Object,
      required: true,
    },
    roomsList: {
      type: Object,
      required: true,
    },
    closeBookingDetails: {
      type: Function,
      required: true,
    },
    refresh: {
      type: Function,
      required: true,
    },
  },
  components: {
    flatPickr
  },
  destroy(){
    this.resetData()
  },
  data() {
    return {
      show: true,
      isSaving: false,
      isProcessingPayment: false,
      isLoadingTransactions: false,
      fechaActual: currentDate(),
      adultOptions,
      childrenOptions,
      ageChildrenOptions,
      namesPrefix,
      amount: 0,
      sum: 0,
      invalid: false,
      isValidNights: false,
      isEdit: false,
      isUpdating: false,
      rangeDate: null,
      setDatein: null,
      setDateout: null,
      nightsValid: this.room?.nights,
      availability: false,
      validPax: this.roomsList,
      isRoomFull: false,
      ismaxPax: false,
      applyPayment: false,
      payment: {
        paymentMethod: null,
        paymentDate: null,
        currency: null,
        amount: null,
        reference: null
      },
      fieldsFull: [
        { key: "date_trans", label: "Fecha", class: "text-nowrap" },
        { key: "trans_status", label: "Estado" },
        {
          key: "paid", label: "Pago", class: "text-nowrap", formatter: value => {
            return toCurrency(value)
          }
        },
        { key: "code_currency", label: "Moneda" },
        { key: "auth", label: "Autorización" },
        { key: "ref", label: "Referencia" },
        { key: "actions", label: "Reembolsar" },
      ],
      fields: [
        { key: "date_trans", label: "Fecha", class: "text-nowrap" },
        { key: "trans_status", label: "Estado" },
        {
          key: "paid", label: "Pago", class: "text-nowrap", formatter: value => {
            return toCurrency(value)
          }
        },
        { key: "code_currency", label: "Moneda" },
        { key: "auth", label: "Autorización" },
        { key: "ref", label: "Referencia" },
      ]
    };
  },
  computed: {
    ...mapState("start", ["currencies"]),
    ...mapState("auth", ["user"]),
    ...mapState("groups", [
      "ninos",
      "numberChildren",
      "roomsTypes",

    ]),
    ...mapState("shop", ["cart", "errors", "paymentFormat"]),

    currencyList(){
      const currencyCode = this.room.listPayOrders[0].code_currency
      return this.currencies.filter(x => x.code == currencyCode)
    },
    balanceBooking() {
      this.sum = this.room.listPayOrders.filter(payment => payment.trans_status == 'Approved').reduce((accum, item) => accum + item.amount, 0)

      return ((Math.round((parseFloat(this.room.total) - parseFloat(this.sum)) * 100) / 100).toFixed(2))
    },
    canRefundPayments(){
      return false
    },
    groupReservationTitle() {
      return `${this.groupData?.name} | POS-${this.room?.orderdetail?.order_id}-${this.room?.orderdetail?.orderdetail_id}`
    },
    configRangeDate() {
      this.validPax = this.room.roomslist.find(
        (item) => item.roomtypecode == this.room.roomtypecode
      );
      this.availability = false
      this.invalid = false;
      this.isValidNights = false;
      this.isEdit = false;
      let config
      let datein = moment(this.room.datein)
      let dateout = moment(this.room.dateout)
      this.setDatein = this.groupData.groupHotelData.checkIn
      this.setDateout = this.groupData.groupHotelData.checkOut
      const nigthsBefore = parseFloat(this.groupData?.groupHotelData?.additionalNightsBefore || this.groupData?.groupHotelData?.additionalNights)
      const nigthsAfter = parseFloat(this.groupData?.groupHotelData?.additionalNightsAfter || this.groupData?.groupHotelData?.additionalNights)

      this.rangeDate = `${this.room.datein} to ${this.room.dateout}`
      if (this.can('groups_menu_show_membership_flexible_dates')) {
        this.groupData.groupHotelData.isFlexibleDate = this.can('groups_menu_show_membership_flexible_dates')
      }


      datein = moment(this.groupData?.groupHotelData?.checkIn).subtract(nigthsBefore, 'days').format('YYYY-MM-DD');
      dateout = moment(this.groupData?.groupHotelData?.checkOut).add(nigthsAfter, 'days').format('YYYY-MM-DD');

      config = { mode: 'range', minDate: datein, maxDate: dateout, static: true }

      return config
    },
    selectedCurrency(){
      return this.currencies.find(currency=> currency.currencyid == this.payment.currency)
    },
    currencyAmount(){
      return this.payment?.amount && this.selectedCurrency?.value ? (this.payment?.amount / this.selectedCurrency?.value).toFixed(2) : 0.00
    },
    paymentMethodList(){
      return [
        {id: 1, name: "Credit Card"},
        {id: 30, name: "Wire Transfer"}
      ]
      // return this.paymentMethods.filter(pm => pm.isownersPayment == false)
    },
  },
  methods: {
    ...mapActions("groups", ["fetchTransactionsBooking", "fetchUpdateRoomsDetail", "fetchRoomBooking", "fetchRatesGroup","handleBookingPayment"]),
    ...mapActions("mySales", ["fetchTransactionPay"]),
    ...mapMutations("groups", [
      "addArrayNinios",
      "setAgeChild",
      "removeAgeChild",
      "setTotalNights"
    ]),

    ageChild(object) {
      return object.edad;
    },
    setPaymentForm(){
      this.payment = {
        paymentMethod: null,
        paymentDate: null,
        currency: null,
        amount: null,
        reference: null
      }
      this.applyPayment = !this.applyPayment
    },
    async getLinkPay(orderdetail) {
      const payload = {
        amount: orderdetail.totalpay,
        order: orderdetail.order_id,
        detail: orderdetail.orderdetail_id,
      };

      this.loadvalid = true
      await this.fetchTransactionPay(payload)
      this.loadvalid = false
      this.urlbank = this.transactionPay.link
    },
    createArrayNinios(numberOfChildren) {
      let ageChildrens = []
      for (let i = 0; i < numberOfChildren.children; i++) {
        ageChildrens.push({ edad: 1 })
      }
      const payload = { ageChildrens, info: numberOfChildren }
      this.addArrayNinios(payload)
    },
    setAgeNinio(indice, edad, room) {
      const payload = { indice, edad, room }
      this.setAgeChild(payload)
    },
    deleteAgeChild(indice, room) {
      const payload = { indice, info: room }

      this.removeAgeChild(payload)
    },
    getNights(room) {
      const datein = moment(this.groupData.groupHotelData.checkIn)
      const dateout = moment(this.groupData.groupHotelData.checkOut)
      this.room.nights = dateout.diff(datein, "days")
      this.room.total = room.rateInit * '0'
    },

    setRangeDaysAndTotalNights(rangeDateNew) {

      if (rangeDateNew.includes("to")) {
        const splitdate = rangeDateNew.split(' to ')

        const datein = moment(splitdate[0])
        const dateout = moment(splitdate[1])
        const dateinContract = moment(this.groupData.groupHotelData.checkIn)
        const dateoutContract = moment(this.groupData.groupHotelData.checkOut)

        this.room.total = this.room.rateInit * 0
        this.room.rateInit = 0
        this.nightsValid = dateout.diff(datein, "days")
        // const sameNight = this.calculateNights(dateout, dateinContract);

        // if (!this.groupData.groupHotelData.isFlexibleDate) {
        //   this.isEdit = true
        //   this.isValidNights = false

        //   const validDates = this.areDatesAfterContractDates(datein, dateout, dateinContract, dateoutContract);
        //   this.isValidNights = !validDates
        // } else {
        //   if (this.groupData.nightsGroup>this.nightsValid ){
        //     this.isValidNights=true
        //   } else {
        //     this.isEdit=true
        //     this.isValidNights=false
        //     if ( sameNight!=0 && this.groupData.groupHotelData.isFlexibleDate) {
        //       this.isValidNights=false
        //     } else {
        //       if (this.groupData.groupHotelData.isFlexibleDate ) {
        //         this.isValidNights=true
        //       }
        //     }
        //   }
        // }

        this.room.nights = dateout.diff(datein, "days");
        this.setDatein = splitdate[0]
        this.setDateout = splitdate[1]

      }
    },

    setCanEdit() {
      const paxTotal = parseFloat(this.room.adults) + parseFloat(this.room.children)

      this.ismaxPax = paxTotal > this.validPax.pax

      this.setRangeDaysAndTotalNights(this.rangeDate)

    },

    validMaxPax(roomCode) {
      this.validPax = this.room.roomslist.find(
        (item) => item.roomtypecode == roomCode
      );


      this.room.adults = 1
      this.room.children = 0
      this.setRangeDaysAndTotalNights(this.rangeDate)
      this.setCanEdit()
      this.createArrayNinios(this.room)

      this.isRoomFull = this.validPax.rooms == 0
      this.isEdit = this.validPax.rooms == 0
    },

    areDatesAfterContractDates(datein, dateout, dateinContract, dateoutContract) {
      return datein <= dateinContract && dateout >= dateoutContract;
    },
    async updateRates(room) {

      const splitdate = this.rangeDate.split(' to ')
      this.setDatein = splitdate[0]
      this.setDateout = splitdate[1]
      this.isUpdating = true;
      const ages = room.booking.ninios.map(item => {
        return item.edad
      })

      const roomParameters = {
        "hotel": room.hotel,
        "groupHotelId": this.groupData.groupHotelData.id,
        "groupId": room.group,
        "roomtypecode": room.roomtypecode,
        "dateIn": this.setDatein,
        "dateOut": this.setDateout,
        "adults": room.adults,
        "nights": room.nights,
        "ninos": ages,
        "isAdmin": true
      }

      const rates = await this.fetchRatesGroup(roomParameters);

      this.isUpdating = false;
      if (rates.total == 0) {
        this.availability = true
        return false
      } else {
        this.availability = false
      }
      this.room.rateInit = rates.rateavg
      this.room.total = rates.total
      this.isUpdating = false;
      this.isEdit = false
    },

    async setPriceNights(room) {
      this.setTotalNights(room);
    },
    async updateRoom(room) {
      room.datein = this.setDatein
      room.dateout = this.setDateout
      this.isSaving = true;
      let passRoom = room.room
      room.roomCategory = this.roomsTypes.find(
        (item) => item.code == room.roomtypecode
      );
      if (room.roomCategory) {
        room.roomtypename = room.roomCategory.name
        room.room = room.roomCategory.id
      }

      room.bookingid = room.id
      room.dateIn = room.datein
      room.dateOut = room.dateout
      room.vendor = room.vendorcode

      room.groupId = room.group
      room.roomId = room.room
      room.nightspay = room.orderdetail.nightspay
      room.partial = false
      room.paymentParcial = room.orderdetail.firstpay

      const ages = room.booking.ninios.map(item => {
        return item.edad
      })

      room.ninos = ages

      const getRoom = await this.fetchUpdateRoomsDetail(room);

      this.isSaving = false;
      this.$root.$emit("bv::hide::modal", "modal-reference" + room.id);

      const payload = {
        idGroup: room.group,
        idRoomOnly: "",
        idRoom: room.room,
        datein: room.datein,
        dateout: room.dateout,
      };
      if (room.room != passRoom) {
        if (getRoom == false) {
          this.availability = true
          return showAlertMessage("No se ha modificado la reserva", "BellIcon", "No se ha podido guardar el registro, por favor inténtelo más tarde o contacte a soporte.", "warning", 4000)
        } else {
          this.availability = false
        }
        await this.refresh()
      }
      this.closeBookingDetails(this.roomsList)
      await this.fetchRoomBooking(payload);

    },
    async makePayment(){
      const valid = await this.$refs.ModalPaymentBookingGroupForm.validate()
      if (!valid) return

      if (parseFloat(this.currencyAmount) > parseFloat(this.room.total)) {
        return showAlertMessage("Monto inválido", "BellIcon", "El importe por pagar es mayor al total de la reserva, por favor cambie la cantidad a pagar.", "warning", 4000)
      }

      this.isProcessingPayment = true;

      if (this.applyPayment){
        this.payment.idUser = this.user.idUser

        const response = await this.handleBookingPayment({
          payment: this.payment,
          orderdetail: this.room?.orderdetail?.orderdetail_id,
          type: 1
        })

        if (response?.status){
          showAlertMessage("Pago realizado", "BellIcon", "Se ha realizado el pago.", "success", 4000)
          if (response?.data) this.refreshTransactions(response?.data)
        } else showAlertMessage("No se pudo realizar el pago", "BellIcon", "Por favor inténtelo más tarde o contacte a sistemas.", "warning", 4000)

      }
      this.isProcessingPayment = false;

    },

    async cancelPayment(transaction){
      const {isConfirmed} = await sweetAlert({
        title: "Reembolsando pago",
        message: "¿Está seguro de reembolsar este pago?",
        icon: 'question',
        confirmButton: "Continuar",
        cancelButton: "Cancelar",
      })

      if (!isConfirmed) return

      this.isLoadingTransactions = true;

      const response = await this.handleBookingPayment({
        orderdetail: this.room?.orderdetail?.orderdetail_id,
        transaction,
        type: 2
      })

      if (response?.status){
        showAlertMessage("Pago reembolsado", "BellIcon", "Se ha reembolsado el pago.", "success", 4000)
        if (response?.data) this.refreshTransactions(response?.data)
      } else showAlertMessage("No se pudo reembolsar el pago", "BellIcon", "Por favor inténtelo más tarde o contacte a sistemas.", "warning", 4000)

      this.isLoadingTransactions = false;

    },
    refreshTransactions(transactions){
      this.isLoadingTransactions= true
      this.room.listPayOrders = transactions
      // this.closeBookingDetails()
      makeTime()
      this.setPaymentForm()
      this.isLoadingTransactions= false
    },
    formatPhoneNumber(event) {
      let keyCode = event.keyCode ? event.keyCode : event.which;
      //43 es +, 48-57(numeros del 0 al 9, 32 espacio, 45 es - )
      const codesAllowed = [32, 43, 45, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57];
      const respuesta = codesAllowed.includes(keyCode);
      if (!respuesta) event.preventDefault()
    },
    calculateNights(dateout, dateinContract) {
      return dateout.diff(dateinContract, "days");
    },
    formatCurrency(amount) {
      return toCurrency(amount)
    },
    resetData(){
      Object.assign(this.$data, this.$options.data())
      this.$refs.ModalEditBookingGroupForm?.reset()
    },
  },
};
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
<style>
table.listPay th {
  padding: 3px;
}


table.listPay td {
  padding: 10px 21px 10px 21px;
}

table.listPay {
  text-align: center;
  font-size: 11px;
}

.modal .modal-header.bg-pagado {
  background-color: #28a745;

}

.bg-disponible {
  background-color: #17a2b8;

}

.modal .modal-header.bg-pendiente {
  background-color: #ffc107;

}

.modal .modal-header.bg-pendiente h5 {
  color: #000;
}

.modal .modal-header.bg-pagado h5 {
  color: #fff;
}

.buttonUpdate.col-md-2 {
  margin: 6px 0 0 0;
}

label.nightsValid {
  TEXT-ALIGN: center;
  display: block;
  /* background: red; */
  /* color: #fff; */
  font-size: 11px;
  margin: -15px 0 0 0;
  background: red;
  color: #fff;
}
</style>
